<template>
    <div id="container">
        <AppHeader id="header" />
        <div id="content">
            <router-view />
        </div>
    </div>
</template>

<script>
import AppHeader from '../../components/ui/AppHeader'

export default {
    components: {
        AppHeader
    }
}
</script>

<style scoped>
#container {
    background: #efefef;
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
}

#header {
    grid-area: header;
    background-color: #ffffff !important;
    border-bottom: 1px solid #dddddd;
    padding: 0px 8px;
    margin-bottom: 8px;
}

#content {
    grid-area: content;
    padding: 0px 8px;
    height: 100%;
    overflow: hidden;
}
</style>